interface CompanyDescriptionProps {
  title: string;
  content: string[];
}

const CompanyDescription = ({ title, content }: CompanyDescriptionProps) => {
  return (
    <section className="mb-12">
      <h2 className="font-heading text-3xl font-semibold text-primary mb-6">
        {title}
      </h2>
      <div className="space-y-4">
        {content.map((paragraph, index) => (
          <p key={index} className="font-body text-base text-foreground leading-relaxed">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};

export default CompanyDescription;